export const pageQuery = `*[_type == "page" && slug.current == $slug][0]{
  title,
  pageType,
  seoTitle,
  seoDescription,
  hero,
  sections[]{
    sectionType,
    heading,
    body,
    body2,
    content,
    image{asset->{url}},
    images[]{asset->{url}},
    pdfs[]{title,description,buttonText,openInNewTab,file{asset->{url}}},
    cards[]{title,subtitle,description,linkText,linkUrl,openInNewTab,image{asset->{url}}}
  },
  pdfs[]{title,description,buttonText,openInNewTab,file{asset->{url}}}
}`

export const siteConfigQuery = `*[_type == "siteConfig" && siteId == $siteId][0]{
  title,
  description,
  url,
  phone,
  email,
  address,
  logo{asset->{url}},
  navigation[]{label,href},
  brochures[]{title,description,buttonText,openInNewTab,file{asset->{url}}},
  hero
}`
